import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AdminOrderRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.admin_order_create === true ||
    permissions.admin_order_edit === true ||
    permissions.admin_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default AdminOrderRouteMiddleware;
